module.exports = __webpack_public_path__ + "img/new_ch_tab_bg2.5636a44f.png";